<div class="w-full h-full flex items-center justify-center content-center">
  <div *ngIf="step === 0 && !loading" class="py-72 w-full flex flex-col gap-12 items-center justify-center content-center appear">
    <fun-overal-message [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="onBtnEvent()"></fun-overal-message>
  </div>

  <div *ngIf="step === 1 && !loading">
    <div class="py-32 w-full flex flex-col gap-72 items-center justify-center content-center appear"
      *ngIf="!iframeLoaded">
      <div class="pt-[32px]"><fun-icon [name]="'wifi'"
          [style]="'w-96 h-96 stroke-[2px] stroke-eggplant-70 animate-gradientX'"></fun-icon></div>
      <p class="text-center font-sans text-h400 md:text-h600 text-eggplant-70 animate-gradientX">{{ 'SCA.VALIDATING' |
        translate }}</p>
    </div>
    <iframe *ngIf="urlSafeCategorize" class="w-full h-full"
      [ngClass]="{ 'min-h-[720px] min-w-[350px] md:min-w-[430px]': iframeLoaded }" [src]="urlSafeCategorize" frameborder="0"
      (load)="charged($event)" #iframe allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
  </div>

  <div *ngIf="step === 2 && !loading">
    <div class="py-32 w-full flex flex-col gap-72 items-center justify-center content-center appear"
      *ngIf="!iframeLoaded">
      <div class="pt-[32px]"><fun-icon [name]="'wifi'"
          [style]="'w-96 h-96 stroke-[2px] stroke-eggplant-70 animate-gradientX'"></fun-icon></div>
      <p class="text-center font-sans text-h400 md:text-h600 text-eggplant-70 animate-gradientX">{{ 'SCA.VALIDATING' |
        translate }}</p>
    </div>
    <iframe *ngIf="urlSafeIdentityVerification" class="w-full h-full"
      [ngClass]="{ 'min-h-[720px] min-w-[350px] md:min-w-[430px]': iframeLoaded }" [src]="urlSafeIdentityVerification" frameborder="0"
      (load)="charged($event)" #iframe allowfullscreen webkitallowfullscreen mozallowfullscreen></iframe>
  </div>

  <div *ngIf="step === 3 && !loading"
    class="py-72 w-full flex flex-col gap-12 items-center justify-center content-center appear">
    <fun-overal-message [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="onBtnEvent()"></fun-overal-message>
  </div>

  <div *ngIf="step === 4 && !loading"
    class="py-72 w-full flex flex-col gap-12 items-center justify-center content-center appear">
    <fun-overal-message [text]="text" [image]="image" [btnList]="btnList" (btnEvent)="finish()"></fun-overal-message>
  </div>

  <fun-spinner *ngIf="loading"></fun-spinner>
</div>
